import { render, staticRenderFns } from "./LinkTenantSettingConfirm.vue?vue&type=template&id=1a4cb508&scoped=true"
import script from "./LinkTenantSettingConfirm.vue?vue&type=script&lang=js"
export * from "./LinkTenantSettingConfirm.vue?vue&type=script&lang=js"
import style0 from "./LinkTenantSettingConfirm.vue?vue&type=style&index=0&id=1a4cb508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4cb508",
  null
  
)

export default component.exports